import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  CommonProvider,
  ErrorMessage,
  LoadingMessage,
  ToastsContainer,
  C,
  selectServicesKappSlug,
} from '@kineticdata/bundle-common';
import { parse } from 'query-string';
import { I18n, CoreForm } from '@kineticdata/react';

import { PageTitle } from './components/shared/PageTitle';
import { Home } from './components/home/Home';
import { SearchResults } from './components/SearchResults';
import { Form } from './components/Form';
import { EditProfile } from './components/EditProfile';
import { News } from './components/news/News';
import { NewsArticle } from './components/news/NewsArticle';
import SettingsApp from '@kineticdata/bundle-settings-custom';
import { CustomModalFormContainer } from './components/CustomModalFormContainer';

const RouterGroup = ({ children }) => children;
const NoAgreementsPage = connect(state => ({
  kappSlug: selectServicesKappSlug(state),
}))(({ kappSlug }) => (
  <div className="page-container">
    <div className="page-panel">
      <div className="portal-page__wrapper">
        <CoreForm kapp={kappSlug} form={C.FORM_SLUG_NO_ACCESS} />
      </div>
    </div>
  </div>
));

const AppComponent = props => {
  return props.render({
    main:
      props.errors.size > 0 ? (
        <ErrorMessage
          title="Unexpected Error"
          message="Sorry, an unexpected error has occurred!"
        />
      ) : props.loading ? (
        <LoadingMessage />
      ) : (
        <I18n>
          <main className={`package-layout package-layout--app`}>
            <PageTitle parts={['Loading...']} />
            <Switch>
              <Route
                exact
                path="/kapps/:kappSlug/forms/:formSlug"
                component={Form}
              />
              <Route
                exact
                path="/kapps/:kappSlug/forms/:formSlug/submissions/:id"
                component={Form}
              />
              <Route exact path="/profile" component={EditProfile} />
              <Redirect
                path="/datastore/forms/:formSlug/submissions/:id"
                to={`${SettingsApp.location}/datastore/:formSlug/:id`}
              />
              <Redirect
                path="/datastore/forms/:formSlug"
                to={`${SettingsApp.location}/datastore/:formSlug/new`}
              />
              <Redirect
                path="/forms/:formSlug/submissions/:id"
                to={`${SettingsApp.location}/datastore/:formSlug/:id`}
              />
              <Redirect
                path="/forms/:formSlug"
                to={`${SettingsApp.location}/datastore/:formSlug/new`}
              />
              {/*<Route exact path="/kapps/:kappSlug" component={Home} />*/}
              {props.profile.validEauthAssuranceLevel ? (
                <RouterGroup default>
                  <Route
                    exact
                    path="/search/:query?"
                    component={SearchResults}
                  />
                  <Route exact path="/news/:id" component={NewsArticle} />
                  <Route exact path="/news" component={News} />
                  <Route default component={Home} />
                </RouterGroup>
              ) : (
                <Route default component={NoAgreementsPage} />
              )}
            </Switch>
          </main>
        </I18n>
      ),
  });
};

const PublicAppComponent = props => {
  return props.render({
    main: (
      <I18n>
        <main className={`package-layout package-layout--app`}>
          <PageTitle parts={['Loading...']} />
          <Switch>
            {props.kapp && (
              <Route
                exact
                path="/kapps/:kappSlug/forms/:formSlug"
                component={Form}
              />
            )}
            {props.kapp && (
              <Route
                exact
                path="/kapps/:kappSlug/forms/:formSlug/submissions/:id"
                component={Form}
              />
            )}
            <Redirect path="/" to={props.authRoute} />
          </Switch>
        </main>
      </I18n>
    ),
  });
};

const mapStateToProps = (state, props) => ({
  loading: state.app.loading,
  errors: state.app.errors,
  profile: state.app.profile,
  kapp: state.app.kapp,
  authRoute: state.app.authRoute,
  location: state.router.location,
});

export const App = connect(mapStateToProps)(AppComponent);
export const PublicApp = connect(mapStateToProps)(PublicAppComponent);

export class AppProvider extends Component {
  render() {
    return (
      <CommonProvider>
        <ToastsContainer duration={5000} />
        <CustomModalFormContainer />
        {this.props.appState.authenticated ? (
          <App
            render={this.props.render}
            path={`${this.props.appState.location}/*`}
          />
        ) : (
          <PublicApp
            render={this.props.render}
            path={`${this.props.appState.location}/*`}
          />
        )}
      </CommonProvider>
    );
  }

  // Used for matching pathname to display this App
  // Not used if package is set as Bundle Package of a Kapp
  static location = '/';

  static hasPublicRoutes = true;

  static shouldHideHeader = ({ location }) =>
    parse(location.search).public !== undefined;
}
